class SectionVideofull{
    constructor(el){
        this.DOM = el;
        // console.log("section-videofull", this.DOM)
    }
    static bind(){
        const elements = document.querySelectorAll('.section-videofull')
        elements.forEach(el => new SectionVideofull(el))
    }
}
SectionVideofull.bind()
        